module.exports = __webpack_public_path__ + "static/media/map-marker-alt-solid.8c8ccb5c.svg";